<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-row justify="center" class="pt-8" no-gutters>
        <v-col xl="8" lg="11" md="11" sm="11" cols="12">
          <v-row justify="center" class="mx-0">
            <v-col cols="12" v-if="claim.code">
              <v-text-field class="mt-n4"
                v-model="claim.code"
                label="Código del reclamo"
                hint="Requerido"
                persistent-hint
                solo
                dense
                disabled>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select class="mt-n4" v-model="claim.type_of_claim_id"
                :items="typesOfClaim"
                item-value="id"
                item-text="name"
                label="Tipo de reclamo"
                hint="Requerido"
                :rules="[rules.required]"
                :loading="loadingTypesOfClaim"
                persistent-hint
                solo
                dense>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea class="mt-n4"
                v-model="claim.description"
                label="Descripción"
                hint="Requerido"
                :rules="[rules.required, rules.minText]"
                persistent-hint
                solo>
              </v-textarea>
            </v-col>
            <v-col cols="12" v-if="claim.answer">
              <v-textarea class="mt-n4"
                v-model="claim.answer"
                label="Respuesta"
                hint="Requerido"
                persistent-hint
                solo
                disabled>
              </v-textarea>
            </v-col>
          </v-row>
          <v-row justify="end" class="mt-n3 pb-6 mx-0">
            <v-col xl="6" lg="6" md="6" sm="12" cols="12">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" :loading="loading" :disabled="!valid" :dark="valid" @click="save">
                Guardar
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'

export default {
  name: 'ClaimForm',
  mixins: [navigationMixin],
  props: {
    claim: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      valid: true,
      loadingTypesOfClaim: false,
      rules: {
        required: value => !!value || 'Requerido.',
        minText: value => (value && value.length >= 20) || 'Minimo 20 caracteres.'
      }
    }
  },
  computed: {
    ...mapState('shared', ['loading', 'typesOfClaim'])
  },
  methods: {
    ...mapActions('shared', ['getTypesOfClaim']),
    ...mapActions('claim', ['createClaim', 'updateClaim']),
    async save () {
      if (!this.$refs.form.validate()) {
        return
      }

      if (this.claim.id === null) {
        await this.createClaim(this.claim)
        this.$emit('save', this.claim)
        return
      }

      await this.updateClaim(this.claim)
      this.$emit('save', this.claim)
    }
  },
  async mounted () {
    this.loadingTypesOfClaim = true
    await this.getTypesOfClaim()
    this.loadingTypesOfClaim = false
  }
}
</script>
